import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import rightSidebarDrawers from 'constants/rightSidebarDrawers';
import { useTranslation } from 'react-i18next';
import { RightSideButtonGroup } from './RightSideBarStyle';

const RightSideBarButtons = ({ handleRightDrawerToggle }) => {
  const { t } = useTranslation();

  const handleClick = useCallback(
    drawerName => () => {
      handleRightDrawerToggle(drawerName);
    },
    [handleRightDrawerToggle]
  );

  useEffect(() => {
    handleRightDrawerToggle('', true);
  }, [handleRightDrawerToggle]);

  return (
    <RightSideButtonGroup>
        <Button color='secondary' variant='contained' onClick={handleClick(rightSidebarDrawers.summary)}>
          {t('Summary')}
        </Button>
    </RightSideButtonGroup>
  );
};

RightSideBarButtons.propTypes = {
  handleRightDrawerToggle: PropTypes.func.isRequired
};

export default RightSideBarButtons;
